async function bootstrap() {
  await import('./appsettings')
    .then(appsettings => appsettings.load())
  await import('./main.js')
}

bootstrap()
  .catch((err) => console.error('Unable to bootstrap application', err))
